import { c as _c } from "react/compiler-runtime";
import type React from 'react';
export const SuperscriptIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path stroke="none" d="M0 0h24v24H0z" fill="none" />;
    t1 = <path d="M5 7l8 10m-8 0l8 -10" />;
    t2 = <path d="M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};